// Generated by BUCKLESCRIPT VERSION 5.0.3, PLEASE EDIT WITH CARE
'use strict';

var Root = require("./components/Root.bs.js");
var React = require("react");
var ReactDOMRe = require("reason-react/src/ReactDOMRe.js");
var GlobalStyles = require("./globalStyles.bs.js");

ReactDOMRe.renderToElementWithId(React.createElement(Root.make, { }), "root");

/*  Not a pure module */
